import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../stores/Hooks';
import { ModalMessageSpinner } from './ModalMessageSpinner';
import { ModalMessageError } from './ModalMessageError';
import * as DateFNS from "date-fns";

export const ModalMessageDoSignature: React.FC<any> = observer(
	() =>
	{
		const { uiState } = useStores();
		const store = uiState.stat;

		uiState.modal.ModalErrorText = store.CertififcateListLoadingError;

		function SelectCertificate(event: React.SyntheticEvent)
		{
			const IsAlmostValid = (event.target as HTMLElement).getAttribute('data-isalmostvalid');
			const Thumbprint = (event.target as HTMLElement).getAttribute('data-thumbprint');
			const Algorithm = (event.target as HTMLElement).getAttribute('data-algorithm');
			if (
				IsAlmostValid !== "true"
				|| !Thumbprint
				|| !Algorithm
			) return;
			store.setCertificateSelectedAlgorithm(Algorithm);
			store.setCertificateSelectedThumbprint(Thumbprint);
		}

		return (
			<>
				{store.CertififcateListLoading && <ModalMessageSpinner />}
				{(!store.CertififcateListLoading && store.CertififcateListLoadingError !== "") && <ModalMessageError />}
				{(!store.CertififcateListLoading && store.CertififcateListLoadingError === "") &&
					<>
						<div className="modal-content">
						<p>Для того чтобы подписать сформированное заявление, выберите соответствующий ключ квалифицированной электронной подписи руководителя оператора ЭДО, действующего от имени организации без доверенности.</p>
							<div className="choose-sertificate">
								{store.CertificateList.map((val) =>
								{
									return (
										<div
											key={val.Thumbprint}
											className={"sertificate"}
										>
											<input
												data-thumbprint={val.Thumbprint}
												data-isalmostvalid={val.IsAlmostValid}
												data-algorithm={val.PublicKey_Algorithm_OID}
												type="radio"
												className="sertificate-switcher"
												name="sertificate"
												id={val.Thumbprint}
												onChange={(e: React.ChangeEvent<HTMLInputElement>) => { if (e.target.checked) { SelectCertificate(e) } }}
												disabled={!val.IsAlmostValid}
											/>
											<label className="sertificate-block" htmlFor={val.Thumbprint}>
												<span className="row">
													<span className="col-md-3"><p className="mb-0 title">Владелец:</p></span>
													<span className="col-md-9"><p className="mb-0 def">{store.GetSubject(val.Subject)}</p></span>
												</span>
												<span className="row">
													<span className="col-md-3"><p className="mb-0 title">Организация:</p></span>
													<span className="col-md-9"><p className="mb-0 def">{val.Subject.get("O")}</p></span>
												</span>
												<span className="row">
													<span className="col-md-3"><p className="mb-0 title">Период действия:</p></span>
													<span className="col-md-9"><p className="mb-0 def">{DateFNS.format(val.ValidFromDate, "dd.MM.yyyy")} - {DateFNS.format(val.ValidToDate,"dd.MM.yyyy")}</p></span>
												</span>
												<span className="row">
													<span className="col-md-3"><p className="mb-0 title">Кем выдан:</p></span>
													<span className="col-md-9"><p className="mb-0 def">{store.GetSubject(val.Issuer)}</p></span>
												</span>
												{!val.IsAlmostValid &&
													<span className="sertificate-tooltip" style={{ top: "20px", left: "480px" }}>
													{val.AlmostValidMessage}
													</span>
												}
											</label>
										</div>);
								})}
							</div>
						</div>
						<div className="modal-footer">
							<div className="d-flex align-items-center">
								<button
									className="btn btn-secondary"
									onClick={() => { uiState.modal.setShowModal(false); }}
								>Отменить</button>
								<button
									className="btn btn-primary ml-auto"
									disabled={store.CertificateSelectedThumbprint.length === 0}
									title={store.CertificateSelectedThumbprint.length === 0 ? "Кликните в доступный сертификат" : ""}
									onClick={() => { store.CreateSign() }}
								>Продолжить</button>
							</div>
						</div>
					</>
				}
			</>
		);
	}
)
